module.exports = __webpack_public_path__ + "static/media/map-icon.89518daa.svg";